export const FIELD_NAMES = {
	ICB: 'icbIndicator',
	PARTY_NAME: 'payToPartyName',
	PARTY_CODE: 'payToParty',
	PARTY_DETAILS: 'partyDetails',
};